import { Directive, Injectable } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";

@Directive({
    
})
@Injectable()
export class CustomValidator implements Validators {


    nameValidator(control: FormControl): { [key: string]: boolean } {
        const nameRegexp: RegExp = /[a-zA-Z0-9.'_+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,6}$/;
        if (control.value && nameRegexp.test(control.value)) {
           return { invalidName: true };
        }
    }

    
}